import * as React from 'react';
import { translate } from 'react-i18next';
import { IItemCardProps } from 'models/itemcard';
import * as c from 'models/constants';
import * as moment from 'moment';
import { BlackButton, WhiteButton } from 'components/Common/Button';
import { IOrderListItem } from 'models/orders/order';
require('./style.css');
interface IProps extends IItemCardProps {
	item: IOrderListItem;
	t?: (key: string, options?: any) => string;
	viewItem?: (id: string) => void;
	cancelOrder?: (id: string) => void;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class OrderItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.handleViewItemClick = this.handleViewItemClick.bind(this);
		this.handleCancelOrderClick = this.handleCancelOrderClick.bind(this);
	}

	private handleViewItemClick() {
		if (this.props.viewItem) {
			this.props.viewItem(this.props.item.id);
		}
	}

	private handleCancelOrderClick() {
		if (this.props.cancelOrder) {
			this.props.cancelOrder(this.props.item.id);
		}
	}

	public render() {
		const { id, addedDate, cancelled } = this.props.item;
		const { t } = this.props;

		return (
			<div className="col-12 fixedPadding">
				<div className="row orderItemCard">
					<div className="col-sm-12 col-md-4 orderDate">
						<p>{t('Orders_OrderItemCard_Label_OrderDate')}</p>
						<p className="dateText">
							<span>{moment(addedDate).format('L')}</span>
						</p>
					</div>
					<div className="col-sm-12 col-md-8 orderButtons">
						<BlackButton onClick={this.handleCancelOrderClick} disabled={cancelled}>
							{t('Orders_OrderItemCard_Button_CancelOrder')}
						</BlackButton>
						<WhiteButton onClick={this.handleViewItemClick}>{t('BSPortal_Common_View')}</WhiteButton>
					</div>
					<div className="col-12 orderNumber">
						<p>{t('Orders_OrderItemCard_Label_OrderNumber')}</p>
						<p className="numberText">{id}</p>
					</div>
				</div>
			</div>
		);
	}
}

export { OrderItemCard };
